import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const promoTextStyles = {
  WebkitBoxOrient: "vertical",
  display: "-webkit-box",
  overflow: "hidden"
};
const priceGroupContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs
};
export {
  priceGroupContainerStyles,
  promoTextStyles
};
